export const TASKS_TEAM_SELECTION = 'TASKS_TEAM_SELECTION';
export const TASKS_STATUS_SELECTION = 'TASKS_STATUS_SELECTION';
export const TASKS_FILTER_RESET = 'TASKS_FILTER_RESET';
export const TASKS_FILTER_VIEW_UPDATE = 'TASKS_FILTER_VIEW_UPDATE';

export function tasksUpdateTeamSelectionAction(selected) {
  return { type: TASKS_TEAM_SELECTION, payload: selected };
}

export function tasksUpdateStatusSelectionAction(selected) {
  return { type: TASKS_STATUS_SELECTION, payload: selected };
}

export function tasksFiltersResetAction() {
  return { type: TASKS_STATUS_SELECTION };
}

export function tasksFilterViewUpdateAction(isOpen) {
  return { type: TASKS_FILTER_VIEW_UPDATE, payload: isOpen };
}
